import { render, staticRenderFns } from "./ModelProfile.vue?vue&type=template&id=679084f9&scoped=true&"
import script from "./ModelProfile.vue?vue&type=script&lang=js&"
export * from "./ModelProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModelProfile.vue?vue&type=style&index=0&id=679084f9&scoped=true&lang=scss&"
import style1 from "./ModelProfile.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ModelProfile.vue?vue&type=style&index=2&id=679084f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679084f9",
  null
  
)

component.options.__file = "ModelProfile.vue"
export default component.exports